import Drawer from "./Drawer";
import { useSession } from "@/security/RouteGuards";
import AccountVerificationModal from "@/components/modals/AccountVerificationModal";

type DashboardLayoutProps = {
  children: React.ReactNode;
};

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const { profile } = useSession();

  return profile ? (
    <Drawer>
      {children}
      <AccountVerificationModal />
    </Drawer>
  ) : (
    <> {children} </>
  );
}
